// extracted by mini-css-extract-plugin
export default {"header":"TableHeader_header__ED3gw","header__scroll":"TableHeader_header__scroll__hB1wx","header__item":"TableHeader_header__item__ylFUz"};